import { ORGANIZATION_MANAGER_DASHBOARD_STATS_MOCK } from './organization-manager-dashboard.mock';
import type {
  DashboardPeriod,
  OrganizationManagerDashboardStatsDto,
} from './organization-manager-dashboard.types';
import { applyDashboardPeriod } from './organization-manager-dashboard.period';

/**
 * Organization-manager executive dashboard stats.
 *
 * Today: returns a typed mock so the UI is wired like a real API consumer.
 * Later: replace `getStats` body with `fetch` / generated client call — keep the DTO
 * and pass `period` as a query param.
 */
export const OrganizationManagerDashboardService = {
  async getStats(
    _organizationId: string,
    period: DashboardPeriod,
  ): Promise<OrganizationManagerDashboardStatsDto> {
    // Simulate network latency so loading states are exercised locally.
    await new Promise((resolve) => setTimeout(resolve, 150));
    return applyDashboardPeriod(
      structuredClone(ORGANIZATION_MANAGER_DASHBOARD_STATS_MOCK),
      period,
    );
  },
};
